var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 25.7C11.06 25.7 7 21.64 7 16.6C7 11.56 11.06 7.5 16.1 7.5C21.14 7.5 25.2 11.56 25.2 16.6C25.2 21.64 21.14 25.7 16.1 25.7ZM16.1 8.9C11.83 8.9 8.4 12.33 8.4 16.6C8.4 20.87 11.83 24.3 16.1 24.3C20.37 24.3 23.8 20.87 23.8 16.6C23.8 12.33 20.37 8.9 16.1 8.9Z",
    fill: "#FFA31A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8775 22.3867L29.1635 28.6727L28.1737 29.6625L21.8877 23.3765L22.8775 22.3867Z",
    fill: "#FFA31A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.845ff100f5251343707eb41fbf47bf3a.svg";
export { ForwardRef as ReactComponent };